export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/80b75883a0cd0372836c692bda084dcf.jpeg"
                alt="株式会社永恒"
                className="w-10 h-10 object-contain rounded-sm"
              />
              <div>
                <div className="text-base font-bold tracking-widest" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  株式会社永恒
                </div>
                <div className="text-[#B8960C] text-xs tracking-widest">EIKOU CORPORATION</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              信頼と革新を礎に、高品質な不動産を通じて持続可能な社会と豊かな生活空間を創造します。
            </p>
            <div className="flex items-center gap-2">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-facebook-fill', 'ri-youtube-line'].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  rel="nofollow"
                  className="w-10 h-10 flex items-center justify-center border border-white/20 text-gray-400 hover:border-[#B8960C] hover:text-[#B8960C] transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest mb-5 border-b border-white/10 pb-3">
              事業内容
            </h4>
            <ul className="space-y-3">
              {[
                { label: '軽鉄下地LGS工事', href: '/services/lgs' },
                { label: 'ボード工事', href: '/services/board' },
                { label: '壁紙クロス工事', href: '/services/wallpaper' },
                { label: '床仕上工事', href: '/services/floor' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-gray-400 text-sm hover:text-[#B8960C] transition-colors cursor-pointer flex items-center gap-2 min-h-[44px]">
                    <i className="ri-arrow-right-s-line text-xs text-[#B8960C]"></i>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest mb-5 border-b border-white/10 pb-3">
              会社情報
            </h4>
            <ul className="space-y-3">
              {[
                { label: '会社概要', href: '#about' },
                { label: '施工実績', href: '#projects' },
                { label: 'お客様の声', href: '#testimonials' },
                { label: 'ニュース', href: '#' },
                { label: '採用情報', href: '#' },
                { label: 'プライバシーポリシー', href: '#' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-gray-400 text-sm hover:text-[#B8960C] transition-colors cursor-pointer flex items-center gap-2 min-h-[44px]">
                    <i className="ri-arrow-right-s-line text-xs text-[#B8960C]"></i>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest mb-5 border-b border-white/10 pb-3">
              お問い合わせ
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-[#B8960C] text-sm"></i>
                </div>
                <div>
                  <div className="text-white text-sm font-medium break-words">0120-000-000</div>
                  <div className="text-gray-500 text-xs mt-0.5">平日 9:00〜18:00</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-[#B8960C] text-sm"></i>
                </div>
                <div className="text-gray-400 text-sm break-words">info@eikou-corp.jp</div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#B8960C] text-sm"></i>
                </div>
                <div className="text-gray-400 text-sm leading-relaxed break-words">
                  東京都港区赤坂1-1-1<br />永恒ビル10F
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <div className="text-gray-500 text-xs tracking-wider">
            © 2025 株式会社永恒 EIKOU CORPORATION. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs">
            <a href="#" className="text-gray-500 hover:text-[#B8960C] transition-colors cursor-pointer min-h-[44px] flex items-center">プライバシーポリシー</a>
            <span className="text-gray-700 hidden md:inline">|</span>
            <a href="#" className="text-gray-500 hover:text-[#B8960C] transition-colors cursor-pointer min-h-[44px] flex items-center">利用規約</a>
            <span className="text-gray-700 hidden md:inline">|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#B8960C] transition-colors cursor-pointer min-h-[44px] flex items-center">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}